export const mutationTypes = {
    openDialog: "[dialog] Open dialog",
    closeDialog: "[dialog] Close dialog",
};

export const getterTypes = {
    getDialog: "[dialog] Get dialog",
};
